module.exports = __webpack_public_path__ + "img/web-service.789852af.gif";